/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 23/11/2023 | Lic. José Luis Aragón Cervantes  | Creación
* ---------------------------------------------------------------------------------------
*/

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import "./styles/app.scss";
import "./styles/portatil.scss";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);
